/**
 * Единые иконка, цвета и описание для разделов «Мои шаблоны»:
 * карточки на /lib, визуал слева от заголовка в LayoutH1 (по маршруту или page.headerIcon).
 */
export const LIB_ENTITY_LIBRARY_META = {
  exercise: {
    icon: 'i-custom-icon-dumbbell-medium',
    iconWrapClass: 'border-emerald-100 bg-emerald-50 text-emerald-700',
    description: 'Ваши упражнения и избранные из каталога',
  },
  article: {
    icon: 'i-custom-icon-book',
    iconWrapClass: 'border-amber-100 bg-amber-50 text-amber-700',
    description: 'Статьи, инструкции и методические материалы.',
  },
  training_program: {
    icon: 'i-custom-icon-calendar-program',
    iconWrapClass: 'border-rose-100 bg-rose-50 text-rose-700',
    description: 'Ваши шаблоны программ тренировок.',
  },
  training_week: {
    icon: 'i-custom-icon-calendar-week',
    iconWrapClass: 'border-blue-100 bg-blue-50 text-blue-700',
    description: 'Ваши шаблоны тренировочных недель.',
  },
  training_day: {
    icon: 'i-custom-icon-calendar-day',
    iconWrapClass: 'border-slate-300 bg-slate-50 text-slate-700',
    description: 'Ваши шаблоны тренировок.',
  },
  archive: {
    icon: 'i-custom-icon-archive',
    iconWrapClass: 'border-gray-200 bg-gray-50 text-gray-600',
    description: 'Удалённые программы, недели и тренировки.',
  },
};

/**
 * Длинные префиксы первыми (конструкторы и /lib/*), чтобы не пересечь
 * training-programs / training-days и т.п.
 */
const PATH_PREFIX_TO_ENTITY_KEY = [
  ['/constructors/training-day-builder', 'training_day'],
  ['/constructors/training-week-builder', 'training_week'],
  ['/constructors/mpg-training-day-generator', 'training_day'],
  ['/constructors/mpg-training-week-generator', 'training_week'],
  ['/constructors/training-program-builder', 'training_program'],
  ['/library/training-days', 'training_day'],
  ['/library/exercises', 'exercise'],
  ['/library/articles', 'article'],
  ['/lib/training-programs', 'training_program'],
  ['/lib/training-weeks', 'training_week'],
  ['/lib/training-days', 'training_day'],
  ['/lib/archive', 'archive'],
  ['/lib/exercises', 'exercise'],
  ['/lib/articles', 'article'],
];

/**
 * @param {string} pathname
 * @returns {keyof typeof LIB_ENTITY_LIBRARY_META | null}
 */
export function getLibEntityKeyForPath(pathname) {
  if (!pathname || typeof pathname !== 'string') return null;
  const p = pathname.startsWith('/') ? pathname : `/${pathname}`;
  if (p.startsWith('/workouts/')) return 'training_day';
  if (p.startsWith('/training-weeks/')) return 'training_week';
  if (p.startsWith('/training-programs/')) return 'training_program';
  for (const [prefix, key] of PATH_PREFIX_TO_ENTITY_KEY) {
    if (p === prefix || p.startsWith(`${prefix}/`)) return key;
  }
  return null;
}

/**
 * Только иконка для заголовка (LayoutH1).
 * @param {string} pathname
 * @returns {{ icon: string, iconWrapClass: string } | null}
 */
export function getLibEntityHeaderVisualFromPath(pathname) {
  const key = getLibEntityKeyForPath(pathname);
  if (!key) return null;
  const meta = LIB_ENTITY_LIBRARY_META[key];
  if (!meta?.icon || !meta?.iconWrapClass) return null;
  return { icon: meta.icon, iconWrapClass: meta.iconWrapClass };
}

/**
 * @param {keyof typeof LIB_ENTITY_LIBRARY_META} entityKey
 * @returns {{ icon: string, iconWrapClass: string } | null}
 */
export function getLibEntityHeaderVisual(entityKey) {
  const meta = LIB_ENTITY_LIBRARY_META[entityKey];
  if (!meta?.icon || !meta?.iconWrapClass) return null;
  return { icon: meta.icon, iconWrapClass: meta.iconWrapClass };
}

/**
 * Слить пункт меню (label, to) с описанием и иконкой для LibLinkCardGrid.
 * @param {{ label: string, to: string }} link
 */
export function mergeLibLibraryLinkCard(link) {
  const key = getLibEntityKeyForPath(link.to);
  if (!key) return { ...link };
  const meta = LIB_ENTITY_LIBRARY_META[key];
  return { ...link, ...meta };
}
